(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dupper-editorial-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dupper-editorial-videos')) {
    customElements.define('dupper-editorial-videos', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('[data-video-track]');
        this.cards = Array.from(this.querySelectorAll('[data-video-card]'));
        this.videos = Array.from(this.querySelectorAll('video'));
        if (!this.track || !this.cards.length) return;
        this.querySelector('[data-video-navigation]').hidden = this.cards.length < 2;
        this.querySelector('[data-video-previous]').addEventListener('click', () => this.move(-1), options);
        this.querySelector('[data-video-next]').addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { passive: true, ...options });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.visibleVideos = new Set();
        this.userPaused = new WeakSet();
        this.pendingPlayback = new WeakSet();
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.reducedMotion.addEventListener('change', () => this.syncPlayback(), options);
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.isIntersecting && entry.intersectionRatio >= .55) this.visibleVideos.add(entry.target);
            else this.visibleVideos.delete(entry.target);
          }
          this.syncPlayback();
        }, { root: null, threshold: [0, .55] });
        for (const video of this.videos) {
          const media = video.closest('[data-video-media]');
          const play = media.querySelector('[data-video-play]');
          const sound = media.querySelector('[data-video-sound]');
          video.controls = false;
          video.muted = true;
          media.querySelector('[data-video-controls]').hidden = false;
          const updatePlay = () => {
            const playing = !video.paused;
            media.dataset.playing = String(playing);
            play.setAttribute('aria-pressed', String(playing));
            play.setAttribute('aria-label', playing ? play.dataset.labelPause : play.dataset.labelPlay);
          };
          play.addEventListener('click', async () => {
            if (!video.paused) {
              this.userPaused.add(video);
              video.pause();
              return;
            }
            this.userPaused.delete(video);
            await this.startVideo(video);
          }, options);
          sound.addEventListener('click', () => {
            const muted = !video.muted;
            if (!muted) for (const other of this.videos) if (other !== video) other.muted = true;
            video.muted = muted;
          }, options);
          video.addEventListener('volumechange', () => {
            media.dataset.muted = String(video.muted);
            sound.setAttribute('aria-pressed', String(!video.muted));
            sound.setAttribute('aria-label', video.muted ? sound.dataset.labelUnmute : sound.dataset.labelMute);
          }, options);
          video.addEventListener('error', () => {
            video.closest('[data-video-card]').querySelector('[data-video-error]').hidden = false;
          }, options);
          video.addEventListener('play', updatePlay, options);
          video.addEventListener('pause', updatePlay, options);
          this.observer.observe(video);
        }
        document.addEventListener('visibilitychange', () => {
          this.syncPlayback();
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }
      async startVideo(video) {
        if (this.pendingPlayback.has(video)) return;
        this.pendingPlayback.add(video);
        try {
          await video.play();
          video.closest('[data-video-card]').querySelector('[data-video-error]').hidden = true;
        } catch (error) {
          if (!['AbortError', 'NotAllowedError'].includes(error.name)) video.closest('[data-video-card]').querySelector('[data-video-error]').hidden = false;
        } finally {
          this.pendingPlayback.delete(video);
        }
      }
      syncPlayback() {
        for (const video of this.videos) {
          if (document.hidden || !this.visibleVideos.has(video)) {
            video.pause();
          } else if (this.reducedMotion.matches) {
            if (!video.paused && !this.userPaused.has(video)) video.pause();
          } else if (!this.userPaused.has(video) && video.paused) {
            this.startVideo(video);
          }
        }
      }
      move(direction) {
        const distance = this.cards[1] ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : this.track.clientWidth;
        this.track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        if (!this.track || !this.cards.length) return;
        const distance = this.cards[1] ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : 1;
        this.querySelector('[data-video-position]').textContent = String(Math.round(this.track.scrollLeft / distance) + 1);
        this.querySelector('[data-video-previous]').disabled = this.track.scrollLeft < 2;
        this.querySelector('[data-video-next]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        for (const video of this.videos || []) video.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dupper-family-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dupper-family-builder')) {
    customElements.define('dupper-family-builder', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-family-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-family-panel]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', event => this.onKeydown(event, index));
        });

        this.querySelectorAll('[data-family-form]').forEach(form => this.setupForm(form));
      }

      setupForm(form) {
        const variantsElement = form.querySelector('[data-family-variants]');
        if (!variantsElement) return;

        let variants = [];
        try {
          variants = JSON.parse(variantsElement.textContent);
        } catch (error) {
          return;
        }

        form._familyVariants = variants;
        form.querySelectorAll('[data-family-option]').forEach(select => {
          Array.from(select.options).forEach(option => {
            option.disabled = !variants.some(variant => variant.available && variant.options.includes(option.value));
          });
          select.addEventListener('change', () => this.syncVariant(form));
        });

        this.syncVariant(form);
      }

      syncVariant(form) {
        const selectedOptions = Array.from(form.querySelectorAll('[data-family-option]')).map(select => select.value);
        const variant = form._familyVariants.find(candidate => candidate.options.every((value, index) => value === selectedOptions[index]));
        const variantInput = form.querySelector('[data-family-variant-id]');
        const submitButton = form.querySelector('[data-family-submit]');
        const price = form.querySelector('[data-family-price]');
        const status = form.querySelector('[data-family-status]');

        if (variant) {
          variantInput.value = variant.id;
          price.textContent = variant.price;
        }

        const available = Boolean(variant && variant.available);
        submitButton.disabled = !available;
        submitButton.textContent = available
          ? submitButton.dataset.addLabel
          : variant
            ? submitButton.dataset.soldLabel
            : submitButton.dataset.unavailableLabel;
        status.textContent = available ? '' : submitButton.textContent;
      }

      select(index) {
        const update = () => {
          this.tabs.forEach((tab, tabIndex) => {
            const selected = tabIndex === index;
            tab.setAttribute('aria-selected', selected ? 'true' : 'false');
            tab.tabIndex = selected ? 0 : -1;
            this.panels[tabIndex].hidden = !selected;
          });
        };

        update();
      }

      onKeydown(event, index) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + this.tabs.length) % this.tabs.length;
        this.select(nextIndex);
        this.tabs[nextIndex].focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dupper-next-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dupper-next-product')) {
    customElements.define('dupper-next-product', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.form = this.querySelector('form[action*="/cart/add"]');
        this.canonical = this.querySelector('[data-next-variant-id]');
        this.selects = Array.from(this.querySelectorAll('[data-next-option]'));
        this.variants = JSON.parse(this.querySelector('[data-next-variants]').textContent);
        if (!this.form || !this.canonical || !this.variants.length) return;
        this.setAttribute('data-enhanced', '');
        this.querySelector('[data-next-canonical]').hidden = true;
        this.querySelector('[data-next-sizes]').hidden = false;
        const breedPicker = this.querySelector('[data-next-breed-picker]');
        if (breedPicker) {
          breedPicker.hidden = false;
          this.querySelector('.dupper-next__breeds').hidden = true;
        }
        this.addEventListener('change', event => {
          if (event.target.matches('[data-next-breed]')) {
            const link = Array.from(this.querySelectorAll('.dupper-next__breeds a')).find(item => item.getAttribute('href') === event.target.value);
            if (link) link.click();
          }
          if (event.target.matches('[data-next-option]')) this.updateVariant(true);
        }, { signal: this.abort.signal });
        this.form.addEventListener('submit', event => {
          const entry = this.findVariant();
          if (!entry || !entry.variant.available || String(entry.variant.id) !== this.canonical.value) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.updateVariant(false);
          }
        }, { capture: true, signal: this.abort.signal });
        this.updateVariant(false);
      }
      findVariant() {
        const values = this.selects.map(select => select.value);
        return this.variants.find(entry => !values.length || entry.variant.options.every((value, index) => value === values[index]));
      }
      updateVariant(updateUrl) {
        const entry = this.findVariant();
        const previousVariant = this.selectedVariant;
        const variant = entry?.variant;
        this.selectedVariant = variant;
        this.canonical.value = variant ? String(variant.id) : '';
        const label = variant ? variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel : this.dataset.unavailableLabel;
        this.querySelectorAll('button[type="submit"]').forEach(button => {
          button.disabled = !variant?.available;
          const buttonLabel = button.querySelector('div') || button;
          if (buttonLabel.children.length === 0) buttonLabel.textContent = label;
          else {
            const text = Array.from(buttonLabel.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
            if (text) text.textContent = label;
          }
        });
        const stickyVariant = this.querySelector('[data-next-sticky-variant]');
        if (stickyVariant) stickyVariant.textContent = variant?.title === 'Default Title' ? '' : variant?.title || '';
        const stickyPrice = this.querySelector('[data-next-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = entry?.price || '';
        this.querySelector('[data-next-availability]').textContent = variant?.available ? '' : label;
        if (entry) {
          this.querySelector('[data-next-price]').textContent = entry.price;
          const compare = this.querySelector('[data-next-compare]');
          compare.textContent = entry.compare;
          compare.hidden = !entry.compare;
        }
        const values = this.selects.map(select => select.value);
        this.selects.forEach((select, index) => {
          for (const option of select.options) {
            const exists = this.variants.some(item => item.variant.options[index] === option.value && item.variant.options.every((value, position) => position >= index || value === values[position]));
            option.disabled = !exists;
          }
        });
        this.form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { formId: this.dataset.formId, variant, previousVariant } }));
        if (updateUrl) {
          const url = new URL(location.href);
          if (variant) url.searchParams.set('variant', variant.id);
          else url.searchParams.delete('variant');
          history.replaceState({ ...history.state }, '', url);
        }
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["judgeme-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dupper-group-reviews')) {
    customElements.define('dupper-group-reviews', class extends HTMLElement {
      static cache = new Map();
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.sources = JSON.parse(this.querySelector('[data-group-review-sources]').textContent);
          this.labels = JSON.parse(this.querySelector('[data-group-review-labels]').textContent);
          this.page = 0;
          this.reviews = [];
          this.abort = new AbortController();
          this.addEventListener('change', event => {
            if (!event.target.matches('[data-group-review-sort]')) return;
            this.page = 0;
            this.render();
          }, { signal: this.abort.signal });
          this.addEventListener('click', event => {
            if (event.target.closest('[data-group-review-retry]')) {
              this.load();
              return;
            }
            const previous = event.target.closest('[data-group-review-previous]');
            const next = event.target.closest('[data-group-review-next]');
            if (!previous && !next) return;
            this.page += next ? 1 : -1;
            this.render();
            this.scrollIntoView({ block: 'start' });
          }, { signal: this.abort.signal });
          if (!this.sources.length) return;
          this.observer = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.load();
          }, { rootMargin: '600px' });
          this.observer.observe(this);
        });
      }
      safeUrl(value) {
        if (!value) return '';
        try {
          const url = new URL(value, location.origin);
          return url.protocol === 'https:' ? url.href : '';
        } catch { return ''; }
      }
      parse(html, source) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.from(doc.querySelectorAll('.jdgm-rev')).filter(row => {
          const url = row.getAttribute('data-product-url');
          return url && new URL(url, location.origin).pathname === new URL(source.url, location.origin).pathname;
        }).map(row => ({
          id: row.getAttribute('data-review-id'),
          product: String(source.id),
          verified: row.getAttribute('data-verified-buyer') === 'true',
          rating: Math.min(5, Math.max(1, Number(row.querySelector('.jdgm-rev__rating')?.getAttribute('data-score')) || 5)),
          author: row.querySelector('.jdgm-rev__author')?.textContent.trim() || '',
          date: row.querySelector('time')?.getAttribute('datetime') || '',
          title: row.querySelector('.jdgm-rev__title')?.textContent.trim() || '',
          paragraphs: Array.from(row.querySelectorAll('.jdgm-rev__body p')).map(p => p.textContent),
          body: row.querySelector('.jdgm-rev__body')?.textContent.trim() || '',
          photos: Array.from(row.querySelectorAll('.jdgm-rev__pic-link')).map(link => ({
            href: this.safeUrl(link.getAttribute('href')),
            src: this.safeUrl(link.querySelector('img')?.getAttribute('data-src') || link.querySelector('img')?.getAttribute('src') || '')
          })).filter(photo => photo.href && photo.src),
          reply: row.querySelector('.jdgm-rev__reply-content')?.textContent.trim() || ''
        })).filter(row => row.id);
      }
      async fetchSource(source) {
        const results = [];
        for (let page = 1; ; page++) {
          const url = new URL('https://cdn.judge.me/reviews/reviews_for_widget');
          url.search = new URLSearchParams({ shop_domain: this.dataset.shop, platform: 'shopify', product_id: source.id, per_page: 100, page });
          const response = await fetch(url, { signal: AbortSignal.timeout(15000) });
          if (!response.ok) throw new Error('Review service unavailable');
          const data = await response.json();
          if (typeof data.html !== 'string') throw new Error('Invalid review response');
          const rows = this.parse(data.html, source);
          results.push(...rows);
          const total = data.total_count == null ? NaN : Number(data.total_count);
          if (rows.length < 100 || Number.isFinite(total) && results.length >= total) break;
        }
        if (results.length < source.count) throw new Error('Incomplete review response');
        return results;
      }
      async load() {
        if (this.loading) return;
        this.loading = true;
        this.setAttribute('aria-busy', 'true');
        this.querySelector('[data-group-review-loading]').hidden = false;
        this.querySelector('[data-group-review-error]').hidden = true;
        try {
          const sources = await Promise.all(this.sources.map(source => {
            const seed = new DOMParser().parseFromString(source.html, 'text/html');
            const updated = seed.querySelector('.jdgm-rev-widg')?.getAttribute('data-updated-at') || '';
            const key = [this.dataset.shop, source.id, source.count, updated].join(':');
            const cache = this.constructor.cache;
            if (!cache.has(key)) {
              if (cache.size > 40) cache.clear();
              cache.set(key, this.fetchSource(source).catch(error => { cache.delete(key); throw error; }));
            }
            return cache.get(key);
          }));
          if (!this.isConnected) return;
          this.reviews = Array.from(new Map(sources.flat().map(row => [row.id, row])).values());
          this.render();
        } catch {
          if (!this.isConnected) return;
          if (!this.reviews.length) this.reviews = Array.from(new Map(this.sources.flatMap(source => this.parse(source.html, source)).map(row => [row.id, row])).values());
          this.render();
          this.querySelector('[data-group-review-error]').hidden = false;
        } finally {
          this.loading = false;
          if (this.isConnected) {
            this.removeAttribute('aria-busy');
            this.querySelector('[data-group-review-loading]').hidden = true;
          }
        }
      }
      render() {
        const sort = this.querySelector('[data-group-review-sort]').value;
        const dateOrder = (a, b) => (Date.parse(b.date) || 0) - (Date.parse(a.date) || 0);
        const rows = [...this.reviews].sort((a, b) => {
          if (sort === 'verified') return Number(b.verified) - Number(a.verified) || dateOrder(a, b);
          if (sort === 'highest') return b.rating - a.rating || dateOrder(a, b);
          if (sort === 'lowest') return a.rating - b.rating || dateOrder(a, b);
          return dateOrder(a, b);
        });
        this.page = Math.max(0, Math.min(this.page, Math.ceil(rows.length / 5) - 1));
        const start = this.page * 5;
        const fragment = document.createDocumentFragment();
        for (const review of rows.slice(start, start + 5)) {
          const card = this.querySelector('[data-group-review-template]').content.cloneNode(true);
          const article = card.querySelector('article');
          article.dataset.reviewId = review.id;
          article.dataset.productId = review.product;
          article.dataset.verifiedBuyer = String(review.verified);
          const stars = card.querySelector('[data-review-stars]');
          stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
          stars.setAttribute('aria-label', this.labels.stars.replace('__RATING__', review.rating));
          card.querySelector('[data-review-author]').textContent = review.author;
          card.querySelector('[data-review-verified]').hidden = !review.verified;
          const date = card.querySelector('[data-review-date]');
          const parsedDate = new Date(review.date);
          date.hidden = !Number.isFinite(parsedDate.getTime());
          if (!date.hidden) {
            date.dateTime = review.date;
            date.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { dateStyle: 'medium' }).format(parsedDate);
          }
          const title = card.querySelector('[data-review-title]');
          title.textContent = review.title;
          title.hidden = !review.title;
          const body = card.querySelector('[data-review-body]');
          for (const text of review.paragraphs.length ? review.paragraphs : [review.body]) {
            const p = document.createElement('p');
            p.textContent = text;
            body.append(p);
          }
          const photos = card.querySelector('[data-review-photos]');
          for (const photo of review.photos) {
            const link = document.createElement('a');
            link.href = photo.href;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            const image = document.createElement('img');
            image.src = photo.src;
            image.alt = this.labels.photo;
            image.loading = 'lazy';
            image.width = 88;
            image.height = 88;
            link.append(image);
            photos.append(link);
          }
          card.querySelector('[data-review-reply]').hidden = !review.reply;
          card.querySelector('[data-review-reply-body]').textContent = review.reply;
          fragment.append(card);
        }
        const allPhotos = Array.from(new Map(this.reviews.flatMap(review => review.photos).map(photo => [photo.href, photo])).values());
        const gallery = this.querySelector('[data-group-review-photo-track]');
        const galleryItems = document.createDocumentFragment();
        for (const photo of allPhotos) {
          const link = document.createElement('a');
          link.href = photo.href;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          const image = document.createElement('img');
          image.src = photo.src;
          image.alt = this.labels.photo;
          image.loading = 'lazy';
          image.width = 104;
          image.height = 104;
          link.append(image);
          galleryItems.append(link);
        }
        gallery.replaceChildren(galleryItems);
        this.querySelector('[data-group-review-gallery]').hidden = allPhotos.length === 0;
        this.querySelector('[data-group-review-list]').replaceChildren(fragment);
        this.querySelector('[data-group-review-empty]').hidden = rows.length > 0;
        const pages = this.querySelector('[data-group-review-pages]');
        pages.hidden = rows.length <= 5;
        pages.querySelector('[data-group-review-previous]').disabled = this.page === 0;
        pages.querySelector('[data-group-review-next]').disabled = start + 5 >= rows.length;
        pages.querySelector('[data-group-review-status]').textContent = this.labels.range.replace('__FIRST__', start + 1).replace('__LAST__', Math.min(start + 5, rows.length)).replace('__COUNT__', rows.length);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
